var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.033,
    height: 152.836,
    viewBox: "0 0 136.033 152.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g{fill:#fff;}.b,.e,.f,.h{fill:none;}.b{stroke:#898b8d;stroke-width:2px;}.b,.e,.h{stroke-linecap:round;}.c,.d{fill:#464646;}.c{font-size:13px;font-family:Barlow-SemiBold, Barlow;font-weight:600;letter-spacing:0.028em;}.e{stroke:#4e4e4e;stroke-width:1.5px;}.e,.h{stroke-linejoin:round;stroke-miterlimit:10;}.g{font-size:11px;font-family:Helvetica-Light, Helvetica;font-weight:300;}.h{stroke:#fff;stroke-width:0.5px;}.i{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 131.632,
    height: 146,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-552 -1073)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(561 1079)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.752,0H107.88c5.341,0,5.753.49,5.753,5.928V122.072c0,5.438-.411,5.928-5.753,5.928H5.752C.411,128,0,127.51,0,122.072V5.928C0,.49.411,0,5.752,0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 88.33,
    transform: "translate(12.894 71.838)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 45.228,
    transform: "translate(12.894 87.838)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 26.943,
    transform: "translate(12.894 103.839)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 87.845,
    transform: "translate(12.894 43.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H87.845",
    transform: "translate(12.894 55.837)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(24 23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Expediente"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(628.354 1166.189)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.212 3.154)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.954 29.078)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.382,102.321c-.4.057-.746.115-1.147.172a8.126,8.126,0,0,1-.229,1.147,8.123,8.123,0,0,0-.459-1.032,7.774,7.774,0,0,1-1.147.115,10.259,10.259,0,0,0,.8-.746,5.444,5.444,0,0,0-.574-.975c.344.172.688.287,1.032.459a11.009,11.009,0,0,1,.8-.86,8.612,8.612,0,0,0-.115,1.147A9.274,9.274,0,0,0,158.382,102.321Z",
    transform: "translate(-155.4 -100.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.463 34.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M155.782,111.893c-.4,0-.746-.057-1.147-.057a8.832,8.832,0,0,1-.459,1.09c-.057-.4-.172-.746-.229-1.147-.4-.057-.746-.057-1.147-.115.344-.172.631-.4.975-.574a7.968,7.968,0,0,0-.344-1.09c.287.229.631.459.918.688.287-.229.631-.459.918-.688a8.374,8.374,0,0,1-.4,1.09C155.151,111.376,155.5,111.606,155.782,111.893Z",
    transform: "translate(-152.8 -110)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.882 39.172)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M151.168,120.494a7.637,7.637,0,0,0-1.09-.287c-.229.344-.459.631-.688.975v-1.147c-.344-.115-.746-.229-1.09-.344.344-.115.688-.229,1.09-.344,0-.4-.057-.746-.057-1.147.229.287.516.574.746.86a8.818,8.818,0,0,0,1.09-.459,5.677,5.677,0,0,1-.631.975C150.709,119.863,150.938,120.15,151.168,120.494Z",
    transform: "translate(-148.3 -118.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.441 43.244)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M144.881,127.938l-1.032-.516c-.287.287-.574.516-.86.8.115-.4.172-.746.287-1.147-.344-.172-.688-.4-.975-.574a6.352,6.352,0,0,0,1.09-.115c.057-.344.115-.746.172-1.09l.516,1.032a10.13,10.13,0,0,0,1.147-.229c-.287.287-.516.574-.8.86A5.084,5.084,0,0,1,144.881,127.938Z",
    transform: "translate(-142.3 -125.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.254 46.513)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M137.237,133.868c-.287-.229-.574-.516-.86-.746-.344.172-.688.4-1.032.574l.516-1.032c-.287-.229-.574-.516-.86-.746a7.03,7.03,0,0,0,1.09.115c.115-.344.287-.688.4-1.032a7.64,7.64,0,0,1,.287,1.09c.4,0,.746.057,1.147.057a5.684,5.684,0,0,1-.975.631A7.639,7.639,0,0,1,137.237,133.868Z",
    transform: "translate(-135 -131)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.437 48.865)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M128.435,138.082c-.229-.287-.459-.631-.688-.918-.344.115-.746.229-1.147.344.229-.287.459-.574.688-.918a8.749,8.749,0,0,1-.631-.918l1.032.344c.229-.287.4-.631.631-.918,0,.4.057.746.057,1.147.344.115.746.172,1.09.287-.344.115-.746.287-1.09.4A7.687,7.687,0,0,1,128.435,138.082Z",
    transform: "translate(-126.6 -135.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.045 50.184)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M118.806,140.325a8.128,8.128,0,0,1-.459-1.032l-1.147.115c.287-.229.574-.516.86-.746-.172-.344-.287-.688-.459-1.032.287.172.631.4.975.574l.8-.8c-.057.344-.115.746-.172,1.147l1.032.516-.574.115-.574.057A6.054,6.054,0,0,0,118.806,140.325Z",
    transform: "translate(-117.2 -137.4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.54 50.184)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M108.976,140.382a8.119,8.119,0,0,1-.229-1.147c-.4-.057-.8-.115-1.147-.172l1.032-.516a8.117,8.117,0,0,0-.229-1.147l.8.8a9.34,9.34,0,0,0,.975-.631c-.115.344-.287.688-.4,1.032.287.229.574.516.918.746-.4,0-.8-.057-1.147-.057A3.341,3.341,0,0,0,108.976,140.382Z",
    transform: "translate(-107.6 -137.4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.148 48.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M99.29,138.282v-1.147c-.4-.115-.746-.287-1.09-.4.4-.115.746-.172,1.09-.287a7.688,7.688,0,0,1,.057-1.147,5.2,5.2,0,0,0,.631.918,7.661,7.661,0,0,0,1.032-.4c-.229.344-.4.631-.631.975.229.287.459.574.746.918-.4-.115-.746-.229-1.147-.344C99.749,137.651,99.519,137.938,99.29,138.282Z",
    transform: "translate(-98.2 -135.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.273 46.628)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M90.446,134.125c.057-.4.172-.746.229-1.147l-.975-.631c.4,0,.8-.057,1.147-.057.115-.344.172-.746.287-1.09a7.659,7.659,0,0,0,.4,1.032,7.838,7.838,0,0,1,1.09-.115,10.6,10.6,0,0,0-.8.8l.516,1.032-.516-.287-.516-.287C91.019,133.609,90.732,133.9,90.446,134.125Z",
    transform: "translate(-89.7 -131.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.029 43.359)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M82.644,128.253a8.127,8.127,0,0,0,.459-1.032,11.018,11.018,0,0,1-.8-.86,7.916,7.916,0,0,0,1.147.172l.516-1.032c.057.344.115.746.172,1.09.344.057.746.057,1.09.115-.344.172-.631.4-.975.574a11.164,11.164,0,0,0,.287,1.147l-.86-.746A9.274,9.274,0,0,0,82.644,128.253Z",
    transform: "translate(-82.3 -125.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.646 39.401)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M76.4,120.894c.229-.287.459-.631.688-.918-.229-.344-.4-.631-.631-.975.344.172.746.287,1.09.459a9.977,9.977,0,0,1,.746-.86c0,.344-.057.746-.057,1.147.344.115.688.229,1.09.344-.344.115-.688.229-1.09.344v1.147c-.229-.287-.459-.631-.688-.918C77.146,120.722,76.744,120.837,76.4,120.894Z",
    transform: "translate(-76.4 -118.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.893 34.756)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M71.6,112.393c.287-.229.574-.516.86-.746a8.356,8.356,0,0,1-.4-1.09,9.339,9.339,0,0,0,.975.631c.287-.229.574-.459.918-.688a6.048,6.048,0,0,0-.287,1.09c.287.172.631.4.975.574a7.772,7.772,0,0,1-1.147.115c-.057.344-.172.746-.229,1.147l-.459-1.09C72.4,112.335,72,112.393,71.6,112.393Z",
    transform: "translate(-71.6 -110.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.344 29.422)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M68.9,102.863l1.032-.516L69.76,101.2c.287.287.516.574.8.86l1.032-.516c-.172.344-.344.631-.516.975a9.522,9.522,0,0,0,.8.746c-.4-.057-.746-.057-1.147-.115-.172.344-.287.688-.459,1.032a8.125,8.125,0,0,1-.229-1.147C69.646,102.978,69.244,102.921,68.9,102.863Z",
    transform: "translate(-68.9 -101.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.916)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M68.3,93.034a7.644,7.644,0,0,1,1.09-.287c.057-.4.057-.8.115-1.147.172.344.4.688.574.975.344-.115.746-.172,1.09-.287-.229.287-.516.574-.746.86a8.751,8.751,0,0,1,.631.918c-.344-.115-.746-.229-1.09-.344-.229.287-.459.631-.688.918V93.493C68.988,93.321,68.644,93.206,68.3,93.034Z",
    transform: "translate(-68.3 -91.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.86 18.468)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M69.8,83.3c.4,0,.746-.057,1.147-.057l.172-.574.172-.574c.115.344.229.746.344,1.09h1.147c-.287.229-.574.459-.918.688a8.123,8.123,0,0,0,.459,1.032c-.344-.172-.631-.4-.975-.574-.287.229-.574.516-.86.746l.287-1.147C70.431,83.706,70.144,83.534,69.8,83.3Z",
    transform: "translate(-69.8 -82.1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.982 13.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M73.5,74.16c.4.057.746.115,1.147.172l.574-1.032c.057.4.057.746.115,1.147.4.057.746.172,1.147.229-.344.172-.688.287-1.032.459.057.4.115.746.172,1.09a10.6,10.6,0,0,1-.8-.8A9.282,9.282,0,0,0,73.787,76l.516-1.032A10.6,10.6,0,0,1,73.5,74.16Z",
    transform: "translate(-73.5 -73.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.137 9.062)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M79.057,66.159c.344.115.746.287,1.09.4l.4-.459.4-.4a7.772,7.772,0,0,0-.115,1.147c.344.172.688.287,1.032.459-.344.057-.746.172-1.09.229a7.314,7.314,0,0,0-.057,1.147c-.229-.287-.4-.631-.631-.975-.344.115-.746.229-1.09.344a10.467,10.467,0,0,1,.746-.918A7.8,7.8,0,0,1,79.057,66.159Z",
    transform: "translate(-79 -65.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.865 5.449)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.016,59.457c.344.229.631.4.975.631l.975-.688a8.361,8.361,0,0,1-.4,1.09c.287.229.631.459.918.688H87.335c-.115.344-.172.746-.287,1.09a7.661,7.661,0,0,1-.4-1.032,7.77,7.77,0,0,0-1.147.115,5.792,5.792,0,0,1,.918-.746A9.106,9.106,0,0,1,86.016,59.457Z",
    transform: "translate(-85.5 -59.4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.338 2.524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M94.218,54.3c.287.287.516.574.8.86a6.214,6.214,0,0,1,1.09-.459c-.229.344-.4.631-.631.975.229.287.516.574.746.86-.344-.057-.746-.172-1.09-.229-.172.344-.344.688-.516.975-.057-.4-.115-.746-.172-1.147-.4-.057-.746-.115-1.147-.172l1.032-.516A7.06,7.06,0,0,0,94.218,54.3Z",
    transform: "translate(-93.3 -54.3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.443 0.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M103.462,51a8.633,8.633,0,0,1,.574.975,8.119,8.119,0,0,0,1.147-.229,10.6,10.6,0,0,1-.8.8,9.281,9.281,0,0,0,.574,1.032,8.128,8.128,0,0,0-1.032-.459l-.688.86c0-.4.057-.746.057-1.147a6.116,6.116,0,0,0-1.09-.4,8.385,8.385,0,0,1,1.147-.287A7.772,7.772,0,0,0,103.462,51Z",
    transform: "translate(-102.2 -51)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M113.206,49.9c.115.344.229.746.344,1.09l1.147.057a9.34,9.34,0,0,1-.975.631c.115.344.229.746.344,1.09-.287-.229-.574-.459-.918-.688l-.86.688c.115-.344.172-.746.287-1.09a5.684,5.684,0,0,0-.975-.631,8.078,8.078,0,0,1,1.147-.057A5.58,5.58,0,0,0,113.206,49.9Z",
    transform: "translate(-111.6 -49.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.397 0.574)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M123.078,50.9a7.776,7.776,0,0,1,.115,1.147c.4.115.746.172,1.147.287l-.516.172-.516.229a7.69,7.69,0,0,1,.057,1.147,9.967,9.967,0,0,0-.746-.86l-1.032.516.516-1.032a10.593,10.593,0,0,0-.8-.8l1.147.229C122.676,51.531,122.906,51.244,123.078,50.9Z",
    transform: "translate(-121.3 -50.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.673 2.351)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M132.507,54c-.057.4-.057.746-.115,1.147l1.032.516c-.4.057-.746.115-1.147.172-.057.4-.115.746-.172,1.147-.172-.344-.344-.688-.516-.975-.344.057-.746.172-1.09.229.229-.287.516-.574.746-.86a9.348,9.348,0,0,0-.631-.975c.344.172.746.287,1.09.459A11.006,11.006,0,0,1,132.507,54Z",
    transform: "translate(-130.5 -54)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.204 5.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M140.809,59.2c-.115.344-.229.746-.344,1.09a10.471,10.471,0,0,1,.918.746,7.687,7.687,0,0,0-1.147-.057c-.115.344-.287.688-.4,1.09-.115-.344-.172-.746-.287-1.09H138.4c.287-.229.574-.459.918-.688a8.361,8.361,0,0,0-.4-1.09c.344.229.631.459.975.688A3.5,3.5,0,0,1,140.809,59.2Z",
    transform: "translate(-138.4 -59.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.104 8.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M147.9,65.659c-.172.344-.4.688-.573.975.229.287.516.631.746.918-.4-.115-.746-.229-1.09-.344-.229.344-.4.631-.631.975a7.688,7.688,0,0,0-.057-1.147c-.344-.057-.746-.172-1.09-.229a8.126,8.126,0,0,1,1.032-.459c-.057-.4-.115-.746-.172-1.147a11.018,11.018,0,0,1,.8.86A7.657,7.657,0,0,0,147.9,65.659Z",
    transform: "translate(-145.2 -65.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.087 13.191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M153.382,73.7c-.287.287-.516.574-.8.86L153.1,75.6c-.344-.172-.688-.4-1.032-.574l-.8.8c.057-.344.115-.746.172-1.09-.344-.172-.688-.287-1.032-.459a7.374,7.374,0,0,1,1.09-.229A7.776,7.776,0,0,0,151.6,72.9a9.274,9.274,0,0,1,.574,1.032C152.637,73.818,153.038,73.76,153.382,73.7Z",
    transform: "translate(-150.4 -72.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.209 18.123)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M157.14,82.7a5.684,5.684,0,0,1-.975.631c.115.4.172.746.287,1.147a9.973,9.973,0,0,0-.86-.746,8.634,8.634,0,0,1-.975.574,7.662,7.662,0,0,0,.4-1.032c-.287-.229-.574-.459-.918-.688h1.147c.115-.344.229-.746.344-1.09.115.4.287.746.344,1.09A4.5,4.5,0,0,0,157.14,82.7Z",
    transform: "translate(-154.1 -81.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.298 23.457)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.925,92.349a6.115,6.115,0,0,1-1.09.4l.057,1.147c-.229-.344-.459-.631-.688-.918a8.355,8.355,0,0,0-1.09.4,8.754,8.754,0,0,0,.631-.918c-.229-.287-.516-.574-.746-.86.344.057.746.172,1.09.229l.287-.516.287-.516c.057.4.057.8.115,1.147A3.058,3.058,0,0,0,158.925,92.349Z",
    transform: "translate(-156 -90.8)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.995 0.956)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 20.508,
    cy: 20.508,
    rx: 20.508,
    ry: 20.508,
    transform: "translate(0 25.528) rotate(-38.492)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M92.523,48.415A25.809,25.809,0,1,1,66.715,74.223,25.848,25.848,0,0,1,92.523,48.415m0-4.015a29.823,29.823,0,1,0,29.823,29.823A29.837,29.837,0,0,0,92.523,44.4Z",
    transform: "translate(-62.7 -44.4)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(628.354 1186.033)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M120.626,79H64.421a29.8,29.8,0,0,0,0,19.959h56.206a29.8,29.8,0,0,0,0-19.959Z",
    transform: "translate(-62.7 -79)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.129 5.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 51.445,
    height: 7.685,
    transform: "translate(0 1.023)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(24.715 8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.535,
    y: 0
  }, "NOM 151"))), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 48.865,
    transform: "translate(4.818 3.212)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 48.865,
    transform: "translate(4.818 17.378)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNom);
export default __webpack_public_path__ + "static/media/NOM.e16c66df13d761a89bb0b5db3f0c0ba0.svg";
export { ForwardRef as ReactComponent };